import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type ArtistAnchorPropsType = {
  artist: LinkableEntityType;
  children?: React.ReactNode;
};

export const ArtistAnchor: React.FC<ArtistAnchorPropsType> = ({
  artist,
  children,
}) => {
  return (
    <Anchor key={artist.id} to={`/artists/$id`} params={{ id: artist.id }}>
      {children ?? artist.name}
    </Anchor>
  );
};
